import {FC} from 'react';
import HeaderFormContent from '../../../Organization/HeaderForm/index';
import {Box} from '@mui/material';
import {LOGIN} from '@/utils/constants';
import {loginFormStyle} from './LoginFormStyle';
import {Formik} from 'formik';
import {initialValues, validationSchema} from './formConfiguration';
import {ILoginForm} from '@/utils/types';
import FormContent from '@/components/Organization/Login/LoginForm/FormContent';

const LoginFormAdmin: FC<ILoginForm> = ({handleSubmitClickHandler, userType}) => {
	return (
		<Box sx={loginFormStyle.wrapper}>
			<HeaderFormContent title={LOGIN} sx={loginFormStyle.title} />

			<Formik initialValues={initialValues} onSubmit={handleSubmitClickHandler} validationSchema={validationSchema}>
				<FormContent userType={userType} />
			</Formik>
		</Box>
	);
};

export default LoginFormAdmin;
